import { ACTION_TYPES, MUTATION_TYPES } from './types';
import {
  getStudentHistory as _getStudentHistory,
  getStudentDetails as _getStudentDetails,
  saveHistorySearch as _saveHistorySearch,
} from '@/services/common/student.api.js';

export default {
  async [ACTION_TYPES.GET_USER_STUDENT_SEARCHED_HISTORY](
    { commit, state },
    forceSaved = false
  ) {
    if (!state.studentSearchHistory?.length || forceSaved) {
      const result = (await _getStudentHistory()).data;
      commit(
        MUTATION_TYPES.SET_STUDENT_SEARCH_HISTORY,
        result?.reverse() || []
      );
    }
  },

  async [ACTION_TYPES.SET_STUDENT_DETAILS]({ commit }, args) {
    await _getStudentDetails(args.studentId, args.autoCreateStudentData).then(
      async (response) => {
        let regStudenId = response.data.mipeStudent?.regStudentId?.replace(
          '-',
          ''
        );
        const student = {
          studentId: response.data.studentId.toString(),
          fullName: response.data.mipeStudent?.fullName,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          statusId: response.data.mipeStudent?.studentStatusCode,
          status: response.data.mipeStudent?.studentStatusDescription,
          impediment: response.data.mipeStudent?.impedimentDescription,
          regStudentId: regStudenId,
          createdDate: args.createdDate,
          canAccess: true,
          isAtConverted: response.data.isAtConverted,
          existsLocally: args.student.existsLocally,
        };
        commit('setSelectedStudent', student);
        await _saveHistorySearch(args.studentId);
      }
    );
  },
};
